import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import Modal from '../../containers/modal.jsx';
import Divider from '../divider/divider.jsx';
import Filter from '../filter/filter.jsx';
import TagButton from '../../containers/tag-button.jsx';
import Spinner from '../spinner/spinner.jsx';

import styles from './library.css';
import Box from '../box/box.jsx';
import { fetchGet, fetchPost } from '../../lib/zswl/api'
import { accessToken } from '../../lib/zswl/request'

const messages = defineMessages({
    filterPlaceholder: {
        id: 'gui.library.filterPlaceholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for library search field'
    },
    allTag: {
        id: 'gui.library.allTag',
        defaultMessage: 'All',
        description: 'Label for library tag to revert to all items after filtering by tag.'
    }
});

const ALL_TAG = { tag: 'all', intlLabel: messages.allTag };
const tagListPrefix = [ALL_TAG];

class CaseLibraryComponent extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClose',
            'handleFilterChange',
            'handleFilterClear',
            'handleTagClick',
            'setFilteredDataRef'
        ]);
        this.state = {
            filterQuery: '',
            selectedTag: ALL_TAG.tag,
            loaded: false,
            caseResourceList: [],
            scratchCases: [],
            tagList: []
        };
    }
    componentDidMount() {
        // Allow the spinner to display before loading the content
        this.getCaseResourceList();
        // if (this.props.setStopHandler) this.props.setStopHandler(this.handlePlayingEnd);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.filterQuery !== this.state.filterQuery ||
            prevState.selectedTag !== this.state.selectedTag) {
            this.scrollToTop();
        }
    }
    handleClose() {
        this.props.onRequestClose();
    }
    handleTagClick(tag) {
        let scratchCases = [];
        let val = this.state.filterQuery;
        if (tag == 'all') {
            this.state.caseResourceList.forEach(item => {
                item.scratchcases && (scratchCases = scratchCases.concat(item.scratchcases.filter(item => item.name.indexOf(val) > -1)));
            })
        } else {
            const selectedItem = this.state.caseResourceList.find(item => item.id == tag);
            selectedItem && (scratchCases = selectedItem.scratchcases.filter(item => item.name.indexOf(val) > -1));
        }
        this.setState({
            selectedTag: tag.toLowerCase(),
            scratchCases
        });
    }
    handleFilterChange(event) {
        const val = event.target.value.replace(/(^\s*)|(\s*$)/g, "");
        let scratchCases = [];
        this.state.caseResourceList.forEach(item => {
            item.scratchcases && (scratchCases = scratchCases.concat(item.scratchcases.filter(item => item.name.indexOf(val) > -1)));
        })
        this.setState({
            filterQuery: val,
            selectedTag: ALL_TAG.tag,
            scratchCases: scratchCases
        });
    }
    handleFilterClear() {
        this.setState({ filterQuery: '' }, function () {
            this.handleTagClick(this.state.selectedTag);
        });

    }
    getFilteredData() {
        if (this.state.selectedTag === 'all') {
            if (!this.state.filterQuery) return this.props.data;
            return this.props.data.filter(dataItem => (
                (dataItem.tags || [])
                    // Second argument to map sets `this`
                    .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                    .concat(dataItem.name ?
                        (typeof dataItem.name === 'string' ?
                            // Use the name if it is a string, else use formatMessage to get the translated name
                            dataItem.name : this.props.intl.formatMessage(dataItem.name.props)
                        ).toLowerCase() :
                        null)
                    .join('\n') // unlikely to partially match newlines
                    .indexOf(this.state.filterQuery.toLowerCase()) !== -1
            ));
        }
        return this.props.data.filter(dataItem => (
            dataItem.tags &&
            dataItem.tags
                .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                .indexOf(this.state.selectedTag) !== -1
        ));
    }
    scrollToTop() {
        this.filteredDataRef.scrollTop = 0;
    }
    setFilteredDataRef(ref) {
        this.filteredDataRef = ref;
    }
    getCaseResourceList() {
        fetchGet('/api/scratch_cases/listAll', {}).then(res => {
            if (res.success) {
                const datas = res.data;
                let scratchCases = [], tagList = [];
                datas.forEach(item => {
                    item.scratchcases && (scratchCases = scratchCases.concat(item.scratchcases));
                    tagList.push({
                        tag: item.id,
                        label: item.name
                    })
                });
                this.setState({
                    scratchCases,
                    caseResourceList: datas,
                    tagList,
                    loaded: true
                })
            }
        });
    }
    //上报使用情况
    handlePostUser(id) {
        if (!accessToken) return;
        fetchPost('/api/scratch_cases/postUser', {
            id
        }).then(res => {
            if (res.success) {

            }
        });
    }
    handleOpenFile(record, e) {
        let _this = this;
        let fileUrl = record.file.url;
        if (fileUrl) {
            // 获取远程sb3文件二进制流
            let xhr = new XMLHttpRequest();
            xhr.open('GET', fileUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (this.status == 200) {
                    let blob = this.response;
                    // 将Blob对象转换成 ArrayBuffer
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (e) {
                        // 打开文件
                        _this.props.vm.loadProject(reader.result)
                        //更新用户行为
                        _this.handlePostUser(record.id);
                    }
                }
            }
            xhr.send();
        }
        this.handleClose();
    }

    render() {
        // console.log("#Components CaseResource", this.props)
        return (
            <Modal
                fullScreen
                contentLabel={this.props.title}
                id={this.props.id}
                onRequestClose={this.handleClose}
            >
                {this.props.tags && (
                    <div className={styles.filterBar}>
                        {(<Filter
                            className={classNames(
                                styles.filterBarItem,
                                styles.filter
                            )}
                            filterQuery={this.state.filterQuery}
                            inputClassName={styles.filterInput}
                            placeholderText={this.props.intl.formatMessage(messages.filterPlaceholder)}
                            onChange={this.handleFilterChange}
                            onClear={this.handleFilterClear}
                        />
                        )}
                        {this.props.tags && (
                            <Divider className={classNames(styles.filterBarItem, styles.divider)} />
                        )}
                        {this.props.tags &&
                            <div className={styles.tagWrapper}>
                                {tagListPrefix.concat(this.state.tagList).map((tagProps, id) => (
                                    <TagButton
                                        active={this.state.selectedTag === tagProps.tag.toLowerCase()}
                                        className={classNames(
                                            styles.filterBarItem,
                                            styles.tagButton,
                                            tagProps.className
                                        )}
                                        key={`tag-button-${id}`}
                                        onClick={this.handleTagClick}
                                        {...tagProps}
                                    />
                                ))}
                            </div>
                        }
                    </div>
                )}
                <div
                    className={classNames(styles.libraryScrollGrid, {
                        [styles.withFilterBar]: this.props.tags
                    })}
                    ref={this.setFilteredDataRef}
                >
                    {this.state.loaded ? this.state.scratchCases.map(dataItem => (
                        <Box
                            className={classNames(
                                styles.libraryItem, {
                                [styles.hidden]: this.props.hidden
                            }
                            )}
                            role="button"
                            tabIndex="0"
                            key={dataItem.id}
                            onClick={(e) => this.handleOpenFile(dataItem, e)}
                        >
                            {/* Layers of wrapping is to prevent layout thrashing on animation */}
                            <Box className={styles.libraryItemImageContainerWrapper}>
                                <Box
                                    className={styles.libraryItemImageContainer}
                                >
                                    <img
                                        className={styles.libraryItemImage}
                                        src={dataItem.cover}
                                    />
                                </Box>
                            </Box>
                            <span className={styles.caseLibraryItemName}>{dataItem.name}</span>
                        </Box>
                    )) : (
                        <div className={styles.spinnerWrapper}>
                            <Spinner
                                large
                                level="primary"
                            />
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
}

CaseLibraryComponent.propTypes = {
    id: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    title: PropTypes.string.isRequired,
};

CaseLibraryComponent.defaultProps = {

};

export default injectIntl(CaseLibraryComponent);
